import React from "react";
import authService from "./AuthService";
import config, { getApiUrl } from "./config";
import {Link} from "react-router-dom";
import "./Platforms.css";
import toast from "react-hot-toast";

type PlatformsProperties = {}

type Platform = {
    name: string
    friendlyName: string
    manufacturer: string
    model: string
}

type PlatformsState = {
    platforms: Array<Platform>
    showUploadDialog: boolean
    dockerImage: File | null
}

class Platforms extends React.Component<PlatformsProperties, PlatformsState> {
    constructor(props: PlatformsProperties) {
        super(props);
        this.state = {
            platforms: new Array<Platform>(),
            showUploadDialog: false,
            dockerImage: null
        }
    }

    componentDidMount() {
        this.fetchPlatforms();
    }

    render() {
        return (
            <div className="Platforms">
                <h2>Platforms</h2>
                {this.state.platforms.length > 0 ? <div className="Platform-list">
                    {this.state.platforms.map((platform) => {
                        return (
                            <Link to={"/component/platform/" + platform.name}
                                  className="Platforms-platform" key={platform.name}>
                                {platform.friendlyName}<small
                                className="Platforms-model">Model: <strong>{platform.model}</strong>, Manufacturer: <strong>{platform.manufacturer}</strong></small>
                            </Link>);
                    })}
                </div> : <div className="Platforms-list">
                    <div className="Platforms-empty">No Platforms found</div>
                </div>}
                <button className="Home-link" onClick={() => this.setState({showUploadDialog: true})}>Upload HAL component</button>
                {this.state.showUploadDialog && <div className="Platforms-upload">
                    <div className="ApplianceComponents-upload-content">
                        <h5>Docker image (tar archive)</h5>
                        <input type="file" accept=".docker"
                               onChange={(e) => this.setState({dockerImage: e.target.files![0]})}/>
                        <div className="Endpoints-newEndpoint-buttons">
                            <button onClick={this.uploadHalComponent}
                                    disabled={this.state.dockerImage === null}>Upload
                            </button>
                            <button onClick={() => this.setState({
                                showUploadDialog: false,
                                dockerImage: null
                            })}>Cancel
                            </button>
                        </div>
                    </div>
                </div>}
            </div>
        );
    }

    private fetchPlatforms() {
        fetch(getApiUrl() + "/v1/component/platform/", {
            headers: [
                ["Accept", "application/json"],
                ["Authorization", authService.authHeader()]
            ]
        })
            .then(response => response.json() as Promise<Platform[]>)
            .then((response) => {
                this.setState({
                    platforms: response
                })
            })
            .catch((error) => {
                console.error(error);
            });
    }

    private uploadHalComponent = () => {
        let data = new FormData();
        data.append('image', this.state.dockerImage!)

        this.setState({
            showUploadDialog: false,
            dockerImage: null
        });

        const response  = fetch(getApiUrl() + "/v1/component/platform/hal/", {
            method: "POST",
            headers: [
                ["Authorization", authService.authHeader()]
            ],
            body: data
        }).then((response) => {
            if (!response.ok) {
                throw new Error("Failed to upload HAL component")
            }
        });

        const _ = toast.promise(response, {
            loading: 'Uploading HAL component...',
            success: 'HAL component uploaded',
            error: 'Failed to upload HAL component'
        });
    }
}

export default Platforms;
